import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";

const CancelShipmentModal = ({ open, onClose, onConfirm, isLoading, shipmentCount }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="cancel-shipment-dialog-title"
      sx={{
        "& .MuiDialog-paper": {
          bgcolor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle id="cancel-shipment-dialog-title">
        Confirm Shipment Cancellation
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: theme.palette.text.primary }}>
          Do you want to cancel {shipmentCount} shipment{shipmentCount === 1 ? "" : "s"}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={isLoading}
          sx={{
            color: theme.palette.text.secondary,
            "&:hover": {
              bgcolor: theme.palette.action.hover,
            },
          }}
        >
          No
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isLoading}
          variant="contained"
          color="error"
          sx={{
            minWidth: 120,
            fontWeight: 600,
            "&:hover": {
              bgcolor: theme.palette.error.dark,
            },
          }}
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
        >
          {isLoading ? "Processing..." : "Yes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelShipmentModal;